import { HttpClientService } from './../httpClient/httpclient.service';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import { CampaignService } from './campaign.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CouponService {
  baseUrl = 'koncentro-promo/campaign';
  messageInstanceId: string;

  constructor(
    private campaignService: CampaignService,
    private http: HttpClientService
  ) {

  }

  /**
   * Restituisce la lista dei Coupon di una Action
   */
   list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`${this.baseUrl}/message-instance/couponList?message_instance_id=${this.messageInstanceId}&` + params.toString());
  }
  //KS-7224
  editCoupon(couponData: any) {
    const id = encodeURIComponent(couponData.id);
    const url = `${this.baseUrl}/message-instance/coupon/${id}`;
    return this.http.put(url, couponData);
  }


  deleteCoupon(couponId: number) {
    return this.http.delete(`${this.baseUrl}/message-instance/couponList/${couponId}`);
  }

  sliderSteps(min: number, max: number, n: number) {
    const step = (max - min) / (n - 1);
    let sliderSteps = [];
    for (let i = 0; i < n; i++) {
      if (i == n - 1) {
        sliderSteps[i] = max;
      } else {
        sliderSteps[i] = min + (i * step);
      }
    }
    return sliderSteps;
  }

  getTradeDriverSuggestion(target, campaignName, coupon) {
    return new Promise((resolve, reject) => {
      Observable.zip(
        this.campaignService.getTradeDriverParamsLimitsSuggestion(target),
        this.campaignService.getTradeDriverParamsValueSuggestion(campaignName)
      ).subscribe(
        ([paramLimits, paramValues]) => {
          coupon.offerta_min = paramLimits.offerta_min;
          coupon.offerta_max = paramLimits.offerta_max;
          coupon.passo_offerta = paramLimits.passo_offerta;
          coupon.offerta_slider = this.sliderSteps(paramLimits.offerta_min, paramLimits.offerta_max, 5);
          coupon.soglia_min = paramLimits.soglia_min;
          coupon.soglia_max = paramLimits.soglia_max;
          coupon.soglia = [paramLimits.soglia_min, paramLimits.soglia_max];
          coupon.passo_soglia = paramLimits.passo_soglia;
          coupon.soglia_slider = this.sliderSteps(paramLimits.soglia_min, paramLimits.soglia_max, 5);
          coupon.stretch_min = paramLimits.stretch_min;
          coupon.stretch_max = paramLimits.stretch_max;
          coupon.passo_stretch = paramLimits.passo_stretch;
          coupon.stretch_slider = this.sliderSteps(paramLimits.stretch_min, paramLimits.stretch_max, 5);
          if (paramValues.length > 0) {
            coupon.offerta = paramValues[0].offerta_utente || coupon.offerta_min + Math.round((coupon.offerta_max - coupon.offerta_min) / 2);
            coupon.stretch = paramValues[0].stretch_utente || coupon.stretch_min + Math.round((coupon.stretch_max - coupon.stretch_min) / 2);
            if (paramValues[0].soglia_min_utente && paramValues[0].soglia_max_utente) {
              coupon.soglia = [paramValues[0].soglia_min_utente, paramValues[0].soglia_max_utente]
            }
            coupon.ampiezza_step = paramValues[0].ampiezza_step_utente || 0;
          } else {
            coupon.offerta = coupon.offerta_min + Math.round((coupon.offerta_max - coupon.offerta_min) / 2);
            coupon.stretch = coupon.stretch_min + Math.round((coupon.stretch_max - coupon.stretch_min) / 2);
            coupon.ampiezza_step = 0;
          }
          resolve(coupon);
        }
      );
    })
  }

  getCategoryCouponSuggestion(target, campaignName, coupon): Promise<any> {
    return new Promise((resolve, reject) => {
      Observable.zip(
        this.campaignService.getCategoryCouponParamsLimitsSuggestion(target),
        this.campaignService.getCategoryCouponParamsValueSuggestion(campaignName)
      ).subscribe(
        ([paramLimits, categories]) => {
          coupon.offerta_min = paramLimits.offerta_min;
          coupon.offerta_max = paramLimits.offerta_max;
          coupon.passo_offerta = paramLimits.passo_offerta;
          coupon.offerta_slider = this.sliderSteps(paramLimits.offerta_min, paramLimits.offerta_max, 5);
          coupon.soglia_min = paramLimits.soglia_min;
          coupon.soglia_max = paramLimits.soglia_max;
          coupon.soglia = [paramLimits.soglia_min, paramLimits.soglia_max];
          coupon.passo_soglia = paramLimits.passo_soglia;
          coupon.soglia_slider = this.sliderSteps(paramLimits.soglia_min, paramLimits.soglia_max, 5);
          coupon.stretch_min = paramLimits.stretch_min;
          coupon.stretch_max = paramLimits.stretch_max;
          coupon.passo_stretch = paramLimits.passo_stretch;
          coupon.stretch_slider = this.sliderSteps(paramLimits.stretch_min, paramLimits.stretch_max, 5);
          coupon.offerta = coupon.offerta_min + Math.round((coupon.offerta_max - coupon.offerta_min) / 2);
          coupon.stretch = coupon.stretch_min + Math.round((coupon.stretch_max - coupon.stretch_min) / 2);
          coupon.ampiezza_step = 0;

          resolve({
            coupon: coupon,
            categories: categories
          });
        }
      );
    })
  }

  getProductCouponSuggestions(businessGoalCode, campaignName, typeCode): Promise<any[]> {
    return new Promise((resolve, reject) => {
      Observable.zip(
        this.campaignService.getProductCouponOfferLimitsSuggestion(businessGoalCode, typeCode),
        this.campaignService.getProductCouponOfferAndProductsSuggestion(campaignName, typeCode)
      ).subscribe(
        ([offerLimits, couponData]) => {
          if (couponData.length > 0) {
            couponData.map(data => {
              data.offerta_min = offerLimits[0].offerta_min;
              data.offerta_max = offerLimits[0].offerta_max;
              data.passo_offerta = offerLimits[0].passo_offerta;
            })
          }
          resolve(couponData);
        },
      );
    })
  }

  updateCoupon(data?) {
    return this.http.post(`${this.baseUrl}/message-instance/updateCoupon`, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/campaign/coupon.service.ts